var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthAndBeauty250DpFfffffFill0Wght200Grad0Opsz48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    viewBox: "0 -960 960 960",
    width: "48px",
    fill: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m224.69-120-137-379.69 193.69-114.08v-226h63.24v226l193.69 114.08-137 379.69H224.69Zm437.08 0q-5.79 0-10.59-4.41t-4.8-11q0-6.59 4.8-10.97 4.8-4.39 10.59-4.39h151.92v-121.69H661.77q-5.79 0-10.59-4.81-4.8-4.8-4.8-10.6 0-6.59 4.8-10.98 4.8-4.38 10.59-4.38h151.92v-121.69H661.77q-5.79 0-10.59-4.81-4.8-4.8-4.8-10.6 0-6.59 4.8-10.98 4.8-4.38 10.59-4.38h151.92v-122.46H661.77q-5.79 0-10.59-4.42-4.8-4.41-4.8-10.61 0-6.2 4.8-10.97 4.8-4.77 10.59-4.77h151.92v-121.7H661.77q-5.79 0-10.59-4.41t-4.8-10.61q0-6.21 4.8-10.98 4.8-4.76 10.59-4.76h149.08q26.38 0 43.92 17.53 17.54 17.54 17.54 43.93v518.46q0 26.38-17.54 43.92Q837.23-120 810.85-120H661.77Zm-414.69-30.77h132l121.15-335-157.77-92.92h-58.92l-157.77 92.92 121.31 335Zm65.54-214.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthAndBeauty250DpFfffffFill0Wght200Grad0Opsz48);
export default __webpack_public_path__ + "static/media/health_and_beauty_250dp_FFFFFF_FILL0_wght200_GRAD0_opsz48.6e63dae149cfaf3cc81f4f5168275bec.svg";
export { ForwardRef as ReactComponent };